import { render, staticRenderFns } from "./BulkUpdateAppointmentsModal.vue?vue&type=template&id=21de3cab"
import script from "./BulkUpdateAppointmentsModal.vue?vue&type=script&lang=js"
export * from "./BulkUpdateAppointmentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports